import {Injectable} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {GlobalCacheService} from './global-cache.service';
import {CommonServiceService} from './common-service.service';
import {ModalConfigService} from '../utils/modal-config.service';
import {TypeUtilService} from '../utils/type-util.service';
import {NzModalService} from 'ng-zorro-antd';
import {ContactusModalComponent} from '../components/contactus-modal/contactus-modal.component';
import {ShowContentModalComponent} from '../../routes/store/article-details/components/show-content-modal/show-content-modal.component';

@Injectable({
  providedIn: 'root'
})
export class NavigateService {

  constructor(
    public router: Router,
    public globalCacheService: GlobalCacheService,
    public commonService: CommonServiceService,
    public modalConfigService: ModalConfigService,
    private typeUtilService: TypeUtilService,
    private nzModalService: NzModalService,
  ) {
  }

  private getNavigationActiveQuery(params: any): any {
    const queryParams: any = {};
    if (params && params.activeId !== undefined && params.activeId !== null && params.activeId !== '') {
      queryParams.activeId = params.activeId;
    }
    if (params && params.activeParentId !== undefined && params.activeParentId !== null && params.activeParentId !== '') {
      queryParams.activeParentId = params.activeParentId;
    }
    return queryParams;
  }

  /**
   * 跳转
   * @param params 跳转数据
   * @param loginPermission 检验登录权限 默认不需要
   * @param replaceUrl 是否保存历史记录
   */
  multiTypeJump(params: any, loginPermission = false, replaceUrl = false): void {
    if (loginPermission) {
      // 检验登录状态
      const userInfo = this.commonService.getLocalStorageByKey('userInfo', null);
      if (!userInfo || !userInfo.id) {
        this.modalConfigService.errMsg('请先登录后在操作');
        return;
      }
    }

    if (!this.typeUtilService.isObject(params)) {
      return;
    }

    if (Object.keys(params).length <= 0 && params?.jumpType) {
      return;
    }

    if (!params?.jumpType) {
      return;
    }

    // 联系我们需要保留调用方的事件对象，其他旧跳转逻辑继续复用原对象。
    const jumpParams = params.jumpType === 'contactus' || params.jumpType === 'showContent' ? {...params} : params;

    // 删除空参数
    for (const key in jumpParams) {
      if (jumpParams[key] === '') {
        delete jumpParams[key];
      }
    }
    // 删除跳转参上的无用参数 name
    Reflect.deleteProperty(jumpParams, 'name');

    switch (jumpParams.jumpType) {
      case 'contactus':
        this.openContactusModal(jumpParams);
        return;
      case 'showContent':
        this.openShowContentModal(jumpParams);
        return;
      case 'home':
        if (jumpParams?.templateId) {
          this.router.navigate(['home'], {
            queryParams: {
              templateId: jumpParams.templateId,
              ...this.getNavigationActiveQuery(jumpParams),
            }
          });
        }
        break;
      case 'template':
        if (jumpParams?.templateId) {
          const {newWindow = false} = jumpParams;
          if (newWindow === true || newWindow === 'true') {
            const url = Object.entries(jumpParams).reduce((pre, [key, value]) => `${pre}${key}=${value}&`, '/detail?');
            window.open(url.substring(0, url.length - 1));
            return;
          }
          this.router.navigate(['detail'], {
            queryParams: {
              ...jumpParams
              // templateId: params.templateId,
            },
            replaceUrl
          });
        }
        break;
      case 'articleDetails':
        if (jumpParams.articleId) {
          this.router.navigate(['detail'], {
            queryParams: {
              articleId: jumpParams.articleId,
              templateId: jumpParams.articleTemplateId || jumpParams.templateId,
              classifyId: jumpParams.articleClassifyId,
              ...this.getNavigationActiveQuery(jumpParams),
            }
          });
        }
        break;
      case 'link':
        if (jumpParams?.link) {
          window.open(jumpParams.link);
        }
        break;
      case 'linkSelf':
        if (jumpParams?.link) {
          window.open(jumpParams.link, '_self');
        }
        break;
    }
  }

  openContactusModal(params: any): void {
    const contactData = JSON.parse(JSON.stringify(this.resolveLanguageData(params) || {}));
    // 弹窗标题在事件绑定里与表单内容按语言一起配置（title），未配置回退默认
    // popupStyle='contact-us-popup'：复刻原迁移项目导航"联系我们"弹窗——
    // modal.info 小卡片：ℹ️ 图标 + 标题 + 留言介绍文本，无遮罩无页脚（禅道 18937）
    const isContactUsPopup = !!params && params.popupStyle === 'contact-us-popup';
    const config: any = {
      nzTitle: contactData.title || params && params.title || '联系我们',
      nzWidth: '520px',
      nzContent: ContactusModalComponent,
      nzWrapClassName: 'vertical-center-modal',
      nzOkText: '提交',
      nzComponentParams: {contactData},
      nzOnOk: (instance: ContactusModalComponent) => instance && instance.submit ? instance.submit() : false
    };
    if (isContactUsPopup) {
      const content = String(contactData.formIntroduction || '').replace(/\n/g, '<br/>');
      this.nzModalService.info({
        nzClassName: 'modal-info-popup',
        nzTitle: contactData.title || params && params.title || '联系我们',
        nzContent: content || '联系我们',
        nzClosable: true,
        nzMaskClosable: true,
        nzMask: false,
        nzMaskStyle: {opacity: '0'},
        nzFooter: null
      });
      return;
    }
    this.nzModalService.create(config);
  }

  openShowContentModal(params: any): void {
    const contentData = JSON.parse(JSON.stringify(this.resolveLanguageData(params) || {}));
    // popupStyle='contact-us-popup'：复刻原迁移项目导航"联系我们"弹窗——
    // modal.info 小卡片：ℹ️ 图标 + 标题 + 配置的展示内容块，无遮罩无页脚（禅道 18937）；
    // 未配置走默认 800px 展示内容弹窗
    if (!!params && params.popupStyle === 'contact-us-popup') {
      this.nzModalService.info({
        nzClassName: 'modal-info-popup',
        nzTitle: contentData.title || params && params.title || '联系我们',
        nzContent: ShowContentModalComponent,
        nzComponentParams: {contentData},
        nzClosable: true,
        nzMaskClosable: true,
        nzMask: false,
        nzMaskStyle: {opacity: '0'},
        nzFooter: null
      });
      return;
    }
    this.nzModalService.create({
      nzTitle: contentData.title || params && params.title || '联系我们',
      nzWidth: '800px',
      nzContent: ShowContentModalComponent,
      nzWrapClassName: 'vertical-center-modal show-content-modal-dialog',
      nzFooter: null,
      nzComponentParams: {contentData}
    });
  }

  /**
   * 按当前语言解析内嵌多语言内容
   * 命中当前语言则取该语言内容，否则回退默认语言('')，未配置多语言时保持原样
   */
  private resolveLanguageData(data: any): any {
    if (!data || !this.typeUtilService.isObject(data)
      || !Array.isArray(data.multiLanguage) || !data.multiLanguage.length) {
      return data;
    }
    const result = {...data};
    Reflect.deleteProperty(result, 'multiLanguage');

    const list = data.multiLanguage;
    const lang = this.commonService.getLocalStorageByKey('language', '') || '';
    const edition = list.find(item => item && item.lang === lang)
      || list.find(item => item && item.lang === '')
      || list[0];
    if (!edition || !edition.data) {
      return result;
    }
    Object.keys(edition.data).forEach(key => result[key] = edition.data[key]);
    return result;
  }
}
